"use strict";
var settings = {
    sdrHost: "http://www.sdr.se"
};

module.exports = settings;


/*****************
 ** WEBPACK FOOTER
 ** ./assets_src/js/config.js
 ** module id = 4
 ** module chunks = 0
 **/